import React from 'react';
import { SliderProvider } from './slider-context';
import styles from './content-slider.module.scss';
import testIds from '@smart-tv/e2e/shared/variables';
import ContentSliderHeader from './content-slider-header';
import ContentSliderNavigation from './content-slider-navigation';
import DragScroll from '@smart-tv/components/drag-scroll/drag-scroll';
import { IS_BROWSER } from '@smart-tv/utils/is-browser';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  hero?: React.ReactNode;
  isHeroRendered?: boolean;
  scrollingRef?: React.RefObject<HTMLDivElement>;
  onShowAll?: () => void;
}

export const ContentSlider: React.FC<Props> = ({
  hero,
  title,
  children,
  isHeroRendered = false,
  scrollingRef,
  onShowAll,
  className,
  ...rest
}) => {
  return (
    <SliderProvider>
      <div className={[styles['content-slider'], className].filter(Boolean).join(' ')} {...rest}>
        {hero && <>{hero}</>}
        {isHeroRendered && (
          <div data-testid={testIds.contentSlider.root}>
            {title && (
              <ContentSliderHeader data-testid={testIds.contentSlider.title} title={title}>
                {IS_BROWSER && (
                  <ContentSliderNavigation
                    scrollingRef={scrollingRef}
                    onShowAll={onShowAll}
                    showAllOnly={true}
                  />
                )}
              </ContentSliderHeader>
            )}
            <div className={styles['content-area']}>
              <DragScroll
                innerRef={scrollingRef}
                direction="horizontal"
                disableDrag={!IS_BROWSER}
                hideScrollbar={true}
                className={styles['wrapper']}
              >
                <div className={styles['content']}>{children}</div>
              </DragScroll>
              {IS_BROWSER && (
                <ContentSliderNavigation scrollingRef={scrollingRef} arrowsOnly={true} />
              )}
            </div>
          </div>
        )}
      </div>
    </SliderProvider>
  );
};

export default ContentSlider;
